export const NUULY_RENT_APP_STORE_LINK = 'https://apps.apple.com/us/app/nuuly/id1511548818';

// using rent constants here as the common homepage has been revised to reflect the unauthenticated rental homepage
export const EMAIL_OPT_IN_LOCATIONS = {
    FOOTER: 'rent-web-footer',
    MODAL: 'rent-web-email-modal',
};
